import React from 'react';
import { Link } from 'react-router-dom';
import { FlaskConical, Home, BookOpen, MapPin, ExternalLink } from 'lucide-react';

const SHOP_URL = 'https://shop.paramountpeptides.com/MARKBECKER';

const Navigation = () => {
  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 font-bold text-xl text-gray-900" data-testid="nav-logo">
            <FlaskConical className="text-blue-600" size={28} />
            <span>PeptideSciences<span className="text-blue-600">.ai</span></span>
          </Link>
          
          {/* Navigation Links */}
          <div className="flex items-center gap-6">
            <Link 
              to="/" 
              className="flex items-center gap-1 text-gray-700 hover:text-blue-600 font-medium transition-colors"
              data-testid="nav-home"
            >
              <Home size={18} />
              <span>Home</span>
            </Link>
            <Link 
              to="/research" 
              className="flex items-center gap-1 text-gray-700 hover:text-blue-600 font-medium transition-colors"
              data-testid="nav-research"
            >
              <BookOpen size={18} />
              <span>Research</span>
            </Link>
            <Link 
              to="/peptide-clinics" 
              className="flex items-center gap-1 text-gray-700 hover:text-blue-600 font-medium transition-colors"
              data-testid="nav-clinics"
            >
              <MapPin size={18} />
              <span>Clinics</span>
            </Link>
            <a 
              href={SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 px-4 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-all"
              data-testid="nav-shop"
            >
              <span>Shop</span>
              <ExternalLink size={16} />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;